/**
 * Tiny external store for room-move hover.
 * Avoids re-rendering the whole Room Board when one linked booking is hovered.
 */

let hoveredBookingId = null;
let leaveTimer = null;
const listeners = new Set();

const emit = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (_) {
      // Ignore subscriber errors so one bad listener cannot break hover.
    }
  });
};

const clearLeaveTimer = () => {
  if (leaveTimer != null) {
    window.clearTimeout(leaveTimer);
    leaveTimer = null;
  }
};

export const subscribeRoomMoveHover = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getRoomMoveHoverBookingId = () => hoveredBookingId;

export const setRoomMoveHoverBookingId = (bookingId) => {
  clearLeaveTimer();
  const next = bookingId == null ? null : (Number(bookingId) || null);
  if (next === hoveredBookingId) return;
  hoveredBookingId = next;
  emit();
};

export const scheduleClearRoomMoveHoverBookingId = (delayMs = 120) => {
  clearLeaveTimer();
  leaveTimer = window.setTimeout(() => {
    leaveTimer = null;
    if (hoveredBookingId == null) return;
    hoveredBookingId = null;
    emit();
  }, delayMs);
};

export const clearRoomMoveHoverBookingId = () => {
  clearLeaveTimer();
  if (hoveredBookingId == null) return;
  hoveredBookingId = null;
  emit();
};
